import { useCallback } from 'react';
import { Box, Tab, TabList, Tabs } from '~/commonComponents';
import { CandidateStatus, CandidateStatusMapper } from '~/domain/PermanentJobs';
import { useEnablePermanentJobMMFeature } from '~/hooks';
import { Colors } from '~/themes/colors';

type TShowAbleCandidateStatus = Exclude<CandidateStatus, CandidateStatus.Cancelled>;

interface ICandidateStatusFilterPanelProps {
  counts: Record<TShowAbleCandidateStatus, number> & { all: number };
  onChange(tab: CandidateStatus | 'all'): void;
}

const MM_TABS = [CandidateStatus.Rejected, CandidateStatus.Hired] as const;
const V1_TABS = [
  CandidateStatus.Applied,
  CandidateStatus.Scheduled,
  CandidateStatus.Interviewed,
  CandidateStatus.Rejected,
  CandidateStatus.Hired,
];

export const CandidateStatusFilterPanel = ({
  counts,
  onChange,
}: ICandidateStatusFilterPanelProps) => {
  const { isEnablePermanentJobMM } = useEnablePermanentJobMMFeature();

  const handleV1TabChange = useCallback(
    (idx: number) => {
      onChange(V1_TABS[idx - 1] || 'all');
    },
    [onChange],
  );

  const handleMMTabChange = useCallback(
    (idx: number) => {
      if (idx === 0) {
        onChange('all');
      } else {
        onChange(MM_TABS[idx - 1]);
      }
    },
    [onChange],
  );

  if (isEnablePermanentJobMM) {
    return (
      <Tabs
        tabListStyle={{ gap: 16, marginBottom: 8 }}
        style={{ alignItems: 'flex-start' }}
        onChangeTab={handleMMTabChange}
      >
        <TabList>
          <Tab
            PrefixComponent={
              <Box
                backgroundColor={Colors.secondary_500}
                borderRadius="100%"
                height={10}
                width={10}
              />
            }
            title={`In Progress${counts.all > 0 ? ` (${counts.all})` : ''}`}
            textStyle={{ fontSize: 20 }}
          />
          {MM_TABS.map((it) => (
            <Tab
              PrefixComponent={
                <Box
                  backgroundColor={CandidateStatusMapper.getColor(it)}
                  borderRadius="100%"
                  height={10}
                  width={10}
                />
              }
              key={it}
              title={`${CandidateStatusMapper.toHumanReadable(it)}${counts[it] > 0 ? ` (${counts[it]})` : ''}`}
              textStyle={{ fontSize: 20 }}
            />
          ))}
        </TabList>
      </Tabs>
    );
  }

  return (
    <Tabs
      tabListStyle={{ gap: 16, marginBottom: 8 }}
      style={{ alignItems: 'flex-start' }}
      onChangeTab={handleV1TabChange}
    >
      <TabList>
        <Tab
          title={`All${counts.all > 0 ? ` (${counts.all})` : ''}`}
          textStyle={{
            fontSize: 20,
          }}
        />
        {V1_TABS.map((it) => (
          <Tab
            PrefixComponent={
              <Box
                backgroundColor={CandidateStatusMapper.getColor(it)}
                borderRadius="100%"
                height={10}
                width={10}
              />
            }
            key={it}
            title={`${CandidateStatusMapper.toHumanReadable(it)}${counts[it as TShowAbleCandidateStatus] > 0 ? ` (${counts[it as TShowAbleCandidateStatus]})` : ''}`}
            textStyle={{
              fontSize: 20,
            }}
          />
        ))}
      </TabList>
    </Tabs>
  );
};
